import { Fragment } from 'react';

import type { ReportStatus } from '@/components/admin/whistleblow/report';

// Four-phase workflow tracker for the Denúncia masthead. Maps the report
// status 1:1 onto the legal flow: Recebida → Acusada → Em análise → Concluída.
// Completed phases show a green check, the current phase is purple, the rest
// are quiet outlines.
const PHASES = ['Recebida', 'Acusada', 'Em análise', 'Concluída'] as const;
const RANK: Record<ReportStatus, number> = {
  pending: 0,
  acknowledged: 1,
  in_progress: 2,
  closed: 3,
};

export function PhaseTracker({ status }: { status: ReportStatus }) {
  const current = RANK[status] ?? 0;

  return (
    <ol className="flex items-center">
      {PHASES.map((label, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <Fragment key={label}>
            {i > 0 && (
              <span
                aria-hidden="true"
                className={`mx-1.5 h-px w-5 ${i <= current ? 'bg-tertiary' : 'bg-line-strong'}`}
              />
            )}
            <li className="flex items-center gap-1.5">
              <span
                className={`flex h-[18px] w-[18px] items-center justify-center rounded-full border text-[10px] font-bold ${
                  done
                    ? 'border-tertiary bg-tertiary text-white'
                    : active
                      ? 'border-primary bg-primary text-white'
                      : 'border-line-strong text-on-surface-light/70'
                }`}
              >
                {done ? (
                  <span className="material-symbols-outlined text-[12px]">check</span>
                ) : (
                  i + 1
                )}
              </span>
              <span
                className={`text-[11px] font-semibold ${
                  done ? 'text-on-surface' : active ? 'text-primary' : 'text-on-surface-light/70'
                }`}
              >
                {label}
              </span>
            </li>
          </Fragment>
        );
      })}
    </ol>
  );
}
